import CustomerListPreview from "./CustomerListPreivew";

const PrintCustomerList: React.FC = () => {
  return (
    <div className="inner-container">
      <CustomerListPreview />
    </div>
  );
};

export default PrintCustomerList;
